import type { ReactNode } from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { NotificationsBell } from "./NotificationsDrawer";
import { WorkspaceSwitcher } from "./WorkspaceSwitcher";
import { ProfileSwitcher } from "./ProfileSwitcher";
import { CurrencyToggle } from "./CurrencyToggle";

export type Crumb = { label: string; to?: string };

export function TopBar({
  crumbs,
  showWorkspaceSwitcher = true,
  menu,
}: {
  crumbs: Crumb[];
  showWorkspaceSwitcher?: boolean;
  menu?: ReactNode;
}) {
  return (
    <header className="flex h-14 shrink-0 items-center justify-between gap-2 border-b border-line bg-card px-3 sm:px-6">
      {/* min-w-0 lets this shrink below its content's natural width instead
          of forcing the header to overflow (pushing the right-side controls
          off-screen) on a narrow phone with a deep crumb trail - the crumbs
          themselves scroll horizontally in their own box instead, same
          overflow-x-auto idiom used elsewhere (e.g. WizardProgress) rather
          than wrapping or clipping. */}
      <nav className="flex min-w-0 items-center gap-1.5 overflow-x-auto text-sm" aria-label="Breadcrumb">
        {menu}
        {crumbs.map((c, i) => (
          <span key={i} className="flex shrink-0 items-center gap-1.5">
            {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-faint" />}
            {c.to ? (
              <Link to={c.to} className="whitespace-nowrap text-mute hover:text-ink">
                {c.label}
              </Link>
            ) : (
              <span className="whitespace-nowrap font-medium text-ink">{c.label}</span>
            )}
          </span>
        ))}
      </nav>
      <div className="flex shrink-0 items-center gap-2">
        <div className="hidden sm:block">
          <CurrencyToggle />
        </div>
        <NotificationsBell />
        {showWorkspaceSwitcher && <WorkspaceSwitcher />}
        <ProfileSwitcher />
      </div>
    </header>
  );
}
